import type { ReactNode } from 'react'

type Props = {
  number: number
  title: string
  isLast?: boolean
  children: ReactNode
}

/** Numbered circle on a vertical line; the shared skeleton of hub phases and install steps. */
export const PhaseRail = ({ number, title, isLast = false, children }: Props) => (
  <section className="relative flex gap-4 pb-8 last:pb-0">
    {!isLast && <span aria-hidden className="absolute left-4 top-9 bottom-0 w-px bg-gray-300" />}
    <span
      aria-hidden
      className="z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-[15px] font-bold text-white"
    >
      {number}
    </span>
    <div className="min-w-0 flex-1">
      <h2 className="mb-3 text-xl font-bold text-gray-900">{title}</h2>
      {children}
    </div>
  </section>
)
